module.exports = __webpack_public_path__ + "static/media/intro-bg-illustration.f8338314.svg";